import React from "react";
import CesiumDrawingFeature, {
  type CesiumDrawingFeatureProps,
} from "./CesiumDrawingFeature";
import MapboxDrawingFeature, {
  type MapboxDrawingFeatureProps,
} from "./MapboxDrawingFeature";

type DrawingFeatureProps =
  | (MapboxDrawingFeatureProps & {
      mapStyle: "mapbox";
    })
  | (CesiumDrawingFeatureProps & {
      mapStyle: "cesium" | "cesium-rendering";
    });

const DrawingFeature = ({ ...props }: DrawingFeatureProps) => {
  if (props.mapStyle === "cesium" || props.mapStyle === "cesium-rendering") {
    return <CesiumDrawingFeature {...props} />;
  }
  return <MapboxDrawingFeature {...props} />;
};

export default DrawingFeature;
